export default __webpack_public_path__ + "static/media/4.37aae071.jpg";